export default __webpack_public_path__ + "static/media/0x3dc6052a693e4a2fc28eb2ea12fe0cfd3bd221d1.06f6ab48.webp";